export const locale = {
    lang: 'pl',
    data: {
        'Dashboard': 'Pulpit',
        'Details': 'Szczegóły',
        'Free': 'Wolne',
        'Training': 'Trening',
        'Client': 'Klient',
        'Employee': 'Pracownik',
        'Card': 'Karta',
        'Speed Level': 'Poziom szybkości',
        'Speed': 'Prędkość',
        'Calories': 'Kalorie',
        'Distance': 'Dystans',
        'Steps': 'Kroki',
        'Collagen': 'Kolagen',
        'Active': 'Aktywny',
        'Infra Level': 'Poziom podczerwieni',
        'Vacu Level': 'Poziom podciśnienia',
        'Lymph': 'Limfodrenaż',
    }
};
